import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { OptOutNode } from '../../types';
import { getIconForNode } from '../data-source-icon';

type OptOutConditionProps = { node: OptOutNode };

export function OptOutCondition({ node }: OptOutConditionProps) {
  const operator = node.inverse ? 'User is not opted out of' : 'User is opted out of';
  return (
    <ConditionViewerItem icon={getIconForNode(node)}>
      {operator} <ConditionViewerTerm>{node.channel ?? 'communications'}</ConditionViewerTerm>
    </ConditionViewerItem>
  );
}
